
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
  import CollapseItem from '@/components/collapse.vue';
  import {
    relegationAssessmentConfigsave,
    relegationAssessmentConfigInit
  }from "@/api/agent_user"
  @Component({  
    name: '',
    components: {
      PageFooter,
      CollapseItem
    }
  })

  export default class ProductList extends Vue {
    private configuration:any = {
      IsOpenRelegationAssessment:true,
      EffectiveDays:'',
      EffectiveOrderCount:'', 
      EffectiveOrderMoney:'',
    }
    private mounted () {
      this.init()
    }
    private async init(){
      try{
        let res = await relegationAssessmentConfigInit({})
        if(res.IsSuccess){
          this.configuration = res.Result
        }
      }finally{
        //
      }
    }
    private test(){
      let data = JSON.parse(JSON.stringify(this.configuration))
      let two = /^\d+(\.\d{1,2})?$/
      if(data.IsOpenRelegationAssessment){
        if(!data.EffectiveDays){
          this.$message.error('请输入天数')
          return false
        }else if(data.EffectiveDays<1||data.EffectiveDays>9999||data.EffectiveDays!=parseInt(data.EffectiveDays)){
          this.$message.error('天数请输入>=1的整数，最多9999')
          return false
        }else if(!data.EffectiveOrderCount){
          this.$message.error('请输入订单数量')
          return false
        }else if(data.EffectiveOrderCount<1||data.EffectiveOrderCount>9999||data.EffectiveOrderCount!=parseInt(data.EffectiveOrderCount)){
          this.$message.error('订单数量请输入>=1的整数，最多9999')
          return false
        }else if(!data.EffectiveOrderMoney){
          this.$message.error('请输入订单金额')
          return false
        }else if(data.EffectiveOrderMoney<0.01||data.EffectiveOrderMoney>999999.99||!two.test(data.EffectiveOrderMoney)){
          this.$message.error('订单金额请输入0.01~999999.99的数值，最多2位小数')
          return false
        }
      }
      return true
    }
    private async save(){
      if(!this.test()) return
      try{
        let data = JSON.parse(JSON.stringify(this.configuration))
        let res = await relegationAssessmentConfigsave(data)
        if(res.IsSuccess){
          this.$message.success('保存成功')
          this.init()
        }
      }finally{
        //
      }
    }
  }
